import _ from 'lodash'
import { ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import { Topology, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { BeckyRequestPayload } from '../types/becky'

const REQUEST_PARAMS = [
	'isEditorMode',
	'viewMode',
	'ck',
	'experiments',
	'isHttps',
	'isUrlMigrated',
	'quickActionsMenuEnabled',
	'v',
	'dfVersion',
]
const MODULE_NAME = 'remote-widget-structure-builder'

const objToQueryParams = (obj: Record<string, string>) => {
	return Object.keys(obj)
		.map((key) => `${key}=${obj[key]}`)
		.join('&')
}

const extractSiteAssetsParams = (str: string) =>
	_.chain(str)
		.split('?')
		.last()
		.split('&')
		.map((x) => x.replace('}', '').replace('{', '').split('='))
		.fromPairs()
		.value()

export const buildWidgetUrl = (
	widgetDataItem: WidgetRefDataItem,
	clientSpecMap: ViewerClientSpecMap,
	{ siteAssetsServerUrl }: Topology,
	requestPayload: BeckyRequestPayload,
	keepWixCodeConnections: any
) => {
	const { appDefinitionId, widgetId, variationId = '' } = widgetDataItem
	const appData = _.find(clientSpecMap, { appDefinitionId })

	const remoteWidgetPageId = _.get(appData, ['widgets', widgetId, 'componentFields', 'appStudioFields', 'id'])

	const siteAssetsData = _.get(appData, ['appFields', 'platform', 'baseUrls', 'siteAssets'])
	const { siteId, metaSiteId, siteRevision } = extractSiteAssetsParams(siteAssetsData)

	const requestParams = _.pick(requestPayload, REQUEST_PARAMS) as Record<string, string>
	const params = {
		appDefId: appDefinitionId,
		devCenterWidgetId: widgetId,
		variationId,
		pageCompId: variationId ? variationId : remoteWidgetPageId,
		siteId,
		metaSiteId,
		siteRevision,
		module: MODULE_NAME,
		moduleVersion: requestPayload.remoteWidgetStructureBuilderVersion,
		keepWixCodeConnections,
		...requestParams,
	}

	return `${siteAssetsServerUrl}/pages/pages/remoteWidgetStructureBuilder?${objToQueryParams(params)}`
}
